import { request } from "./client";
import type { LibraryResponse, PlaylistSummary } from "./types";

export function getLibrary(): Promise<LibraryResponse> {
  return request<LibraryResponse>("/api/playlists");
}

export function addSongToPlaylist(
  playlistSlug: string,
  jobId: string,
): Promise<PlaylistSummary> {
  return request<PlaylistSummary>(
    `/api/playlists/${playlistSlug}/songs/${jobId}`,
    { method: "POST" },
  );
}

export function removeSongFromPlaylist(
  playlistSlug: string,
  jobId: string,
): Promise<void> {
  return request<void>(`/api/playlists/${playlistSlug}/songs/${jobId}`, {
    method: "DELETE",
  });
}
